import React, { useState } from 'react';
import { FaUser, FaEnvelope, FaBuilding, FaLock, FaEye, FaEyeSlash, FaCamera } from 'react-icons/fa';
import axiosInstance from '../api/axiosInstance';
import { useNavigate, Link } from 'react-router-dom';

const AdminSignup = () => {
  const [formData, setFormData] = useState({
    username: '',
    email: '',
    company: '',
    password: '',
    profileImage: null,
  });

  const [preview, setPreview] = useState(null);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'profileImage' && files[0]) {
      setFormData({ ...formData, profileImage: files[0] });
      setPreview(URL.createObjectURL(files[0]));
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
  e.preventDefault();
  const data = new FormData();
  Object.entries(formData).forEach(([key, value]) => {
    data.append(key, value);
  });

  try {
    const res = await axiosInstance.post('/signup', data);

    alert(res.data.message);
    navigate('/company-register'); 
  } catch (err) {
    alert(err.response?.data?.message || 'Signup failed');
  }
};

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-purple-200 via-white to-purple-300 p-4">
      {/* Back Button */}
      <button
        type="button"
        onClick={() => navigate(-1)}
        className="absolute top-4 left-4 flex items-center gap-2 text-purple-600 hover:text-purple-800 font-medium"
      >
        ← Back
      </button>

      <div className="bg-white rounded-2xl shadow-xl w-full max-w-lg p-8 space-y-6">
        {/* Header */}
        <div className="text-center">
          <h1 className="text-3xl font-extrabold text-purple-700 tracking-wide font-mono">
            Admin SignUp
          </h1>
          {/* <p className="text-sm text-gray-500">with Face Recognition</p> */}
        </div>

        {/* Profile Image Section (WhatsApp-style) */}
        <div className="flex justify-center relative">
          <div className="relative w-28 h-28">
            <img
              src={preview || 'https://cdn-icons-png.flaticon.com/512/149/149071.png'}
              alt="Profile"
              className="w-28 h-28 object-cover rounded-full border-4 border-purple-300"
            />
            <label
              htmlFor="profileImage"
              className="absolute bottom-1 right-1 bg-white p-2 rounded-full shadow cursor-pointer"
            >
              <FaCamera className="text-purple-600" />
            </label>
            <input
              type="file"
              id="profileImage"
              name="profileImage"
              accept="image/*"
              onChange={handleChange}
              className="hidden"
            />
          </div>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="space-y-5">
          {/* Floating Inputs with Icons */}
          {[
            { name: 'username', label: 'Username', type: 'text', icon: <FaUser /> },
            { name: 'email', label: 'Email', type: 'email', icon: <FaEnvelope /> },
            { name: 'company', label: 'Company Name', type: 'text', icon: <FaBuilding /> },
          ].map(({ name, label, type, icon }) => (
            <div key={name} className="relative">
              <div className="absolute left-3 top-3 text-gray-400">{icon}</div>
              <input
                type={type}
                name={name}
                id={name}
                required
                onChange={handleChange}
                placeholder={label}
                className="peer pl-10 h-12 w-full border-b-2 border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-purple-600"
              />
              <label
                htmlFor={name}
                className="absolute left-10 -top-3.5 text-sm text-gray-600 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-purple-600"
              >
                {label}
              </label>
            </div>
          ))}

          {/* Password with Toggle */}
          <div className="relative">
            <div className="absolute left-3 top-3 text-gray-400">
              <FaLock />
            </div>
            <input
              type={showPassword ? 'text' : 'password'}
              name="password"
              id="password"
              placeholder="Password"
              required
              onChange={handleChange}
              className="peer pl-10 pr-10 h-12 w-full border-b-2 border-gray-300 text-gray-900 placeholder-transparent focus:outline-none focus:border-purple-600"
            />
            <label
              htmlFor="password"
              className="absolute left-10 -top-3.5 text-sm text-gray-600 transition-all peer-placeholder-shown:text-base peer-placeholder-shown:text-gray-400 peer-placeholder-shown:top-3 peer-focus:-top-3.5 peer-focus:text-sm peer-focus:text-purple-600"
            >
              Password
            </label>
            <div
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-3 cursor-pointer text-gray-400"
            >
              {showPassword ? <FaEyeSlash /> : <FaEye />}
            </div>
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-gradient-to-r from-purple-600 to-pink-600 text-white font-semibold py-3 rounded-lg hover:opacity-90 transition duration-300"
          >
            Register as Admin
          </button>

          {/* <p className="text-center text-sm text-gray-600 mt-2">
            Already have an account?{' '}
            <Link to="/login" className="text-purple-600 font-semibold hover:underline">
              Login
            </Link>
          </p> */}
        </form>
      </div>
    </div>
  );
};

export default AdminSignup;
